import type { Wells_Bool_Exp } from "gql/api";

export function wellsByUwiorName(text?: string): Wells_Bool_Exp {
  if (!text) return {};

  return {
    _or: [
      { well_name: { _ilike: `%${text}%` } },
      { well_uwi: { _ilike: `%${text}%` } }
    ]
  };
}

export function wellsByUser(user?: string): Wells_Bool_Exp {
  if (!user) return {};

  return {
    _or: [
      {
        sizings: { journal_author_id: { _eq: user } }
      },
      {
        sizings: { scenarios: { journal_author_id: { _eq: user } } }
      }
    ]
  };
}

export function withoutTbdWell(): Wells_Bool_Exp {
  return {
    id: { _neq: 0 }
  };
}
